export default {
  getToken(state) {
    const isExpire = (!state.account.exparation || Date.now() > state.account.exparation);
    if (state.needCheckExparation && isExpire) {
      return '';
    }

    return state.account.token;
  },
  getCurrentUser(state) {
    return state.user.data;
  },
  isAuth(state, getters) {
    return !!(getters.getToken && getters.getToken.length > 0);
  },
  checkRight(state, getters) {
    return (code) => {
      const user = getters.getCurrentUser;
      const rights = user ? user.scopes : [];

      return rights.indexOf(code) !== -1;
    };
  },
  getSidebarByRights(state, getters) {
    return state.sidebar.items.filter((item) => {
      if (!getters.getCurrentUser) {
        return false;
      }

      if (!item.rights || item.rights.length === 0) {
        return true;
      }

      let bRes = true;

      for (let i = 0; i < item.rights.length; i += 1) {
        bRes = getters.checkRight(item.rights[i]);
        if (!bRes) break;
      }

      return bRes;
    });
  },
};
